import { render, staticRenderFns } from "./NoSegments.vue?vue&type=template&id=372e02a0&scoped=true"
var script = {}
import style0 from "./NoSegments.vue?vue&type=style&index=0&id=372e02a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372e02a0",
  null
  
)

export default component.exports